import { LoadingButton } from "@mui/lab";
import { Button, Grid, Stack, TextField } from "@mui/material";
import { CommonModal } from "components/molecules";
import { isEmpty } from "lodash";
import React, { useState } from "react";
import { PrintActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import { I18nTranslator, translations } from "utils/i18n";

const ChangePasswordModal = (props: {
  open: boolean;
  onConfirm(password: string): void;
  onClose(): void;
}) => {
  const { open, onClose, onConfirm } = props;
  const [error, setError] = useState<string>("");

  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const handleSubmit = () => {
    if (password !== confirmPassword) {
      setError(I18nTranslator(translations.yupError.passwordNotMatch));
    } else {
      onConfirm(password);
    }
  };
  const handleClose = () => {
    setPassword("");
    setConfirmPassword("");
    setError("");
    onClose();
  };

  const handleChangeText = (callback: () => void) => {
    setError("");
    callback();
  };
  const renderFooter = () => {
    return (
      <Footer
        disableConfirm={isEmpty(password) && isEmpty(confirmPassword)}
        onClose={handleClose}
        onConfirm={handleSubmit}
      />
    );
  };

  return (
    <CommonModal
      title={I18nTranslator(translations.masterData.changePassword)}
      open={open}
      FooterComponent={renderFooter()}
      handleClose={handleClose}
    >
      <Grid container xs={12} columnSpacing={2}>
        <Grid xs={6} container item>
          <TextField
            error={!isEmpty(error)}
            value={password}
            onChange={(event) =>
              handleChangeText(() => {
                setPassword(event.target.value);
              })
            }
            label={I18nTranslator(translations.masterData.password)}
            type={"password"}
            fullWidth
            helperText={error}
          />
        </Grid>
        <Grid xs={6} container item>
          <TextField
            error={!isEmpty(error)}
            value={confirmPassword}
            onChange={(event) =>
              handleChangeText(() => {
                setConfirmPassword(event.target.value);
              })
            }
            label={I18nTranslator(translations.masterData.confirmPassword)}
            type={"password"}
            fullWidth
            helperText={error}
          />
        </Grid>
      </Grid>
    </CommonModal>
  );
};

const Footer = (props: {
  disableConfirm: boolean;
  onConfirm(): void;
  onClose(): void;
}) => {
  const { disableConfirm, onConfirm, onClose } = props;
  const action = useAppSelector((state) => state.PrintReducer.action);
  return (
    <Stack direction={"row"} spacing={2} justifyContent={"flex-end"}>
      <Button onClick={onClose}>
        {I18nTranslator(translations.button.close)}
      </Button>
      <LoadingButton
        loading={action.includes(PrintActions.print.requestName)}
        disabled={disableConfirm}
        onClick={onConfirm}
        variant="contained"
      >
        {I18nTranslator(translations.button.changePassword)}
      </LoadingButton>
    </Stack>
  );
};
export default ChangePasswordModal;
